// Product Variant Selector

class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }
    connectedCallback() {
      this.onVariantChange
    }
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
        this.updatePriceNew();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
  
      if (!this.currentVariant.available) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        console.log(this.currentVariant)
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        this.setAvailable();
      }
    }
  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const currentImage = document.querySelector("[data-swiper-slide-index='0']").firstChild.nextSibling;
      const swiper = document.querySelector(".swiper-wrapper")
      const width = window.innerWidth
      swiper.style = width < 770 ? `transition-duration: 0ms; transform: translate3d(calc(-${width}px + 20px), 0px, 0px); height: 536px;` : width < 1330 ?
      `transition-duration: 0ms; transform: translate3d(calc(-${width}px / 2 + 20px), 0px, 0px); height: 536px;` : 
      `transition-duration: 0ms; transform: translate3d(-630px, 0px, 0px); height: 536px;`
  
      currentImage.src = this.currentVariant.featured_image.src
    
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
  
        if (source && destination) destination.innerHTML = source.innerHTML;
  
        const price = document.getElementById(`price-${this.dataset.section}`);
  
        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, 'SOLD OUT' );
      });
    }
    updatePriceNew() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const oldPrice = document.getElementById(id);
        const newPrice = html.getElementById(id);
        if(oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
      });
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById("#product-form");
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
  
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      document.getElementById("product-form-contact").style.display = "block";
      const button = document.getElementById(`#product-form`);
      const addButton = document.getElementById('addToCartButton').setAttribute('disabled', 'disabled');
      const addButtonText = document.getElementById('addCartText').textContent = "SOLD OUT";
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      if (!addButton) return;
      if (price) price.classList.add('visibility-hidden');
    }
    setAvailable(){
      document.getElementById("product-form-contact").style.display = "none";
      const button = document.getElementById(`#product-form`);
      const addButton = document.getElementById('addToCartButton').removeAttribute('disabled');;
      document.getElementById('addCartText').textContent = "ADD TO CART";
      if (!addButton) return;
      if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class VariantSelector extends HTMLElement {
        constructor() {
          super();
          this.addEventListener("change", this.onVariantChange);
        }
        onVariantChange() {
          this.getSelectedOptions();
          this.getSelectedVariant();
          if(this.currentVariant) {
            this.updateURL();
            this.updateFormID();
            this.updatePrice();
          }
        }
        getSelectedOptions() {
          this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
          console.log(this.options);
        }
        getVariantJSON() {
          this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
          return this.variantData;
        }
        getSelectedVariant() {
          this.currentVariant = this.getVariantJSON().find(
            (variant) => {
              const findings = !variant.options.map(
                (option, index) => {
                  return this.options[index] === option;
                }
              ).includes(false);
              if(findings) return variant;
            }
          );
          console.log(this.currentVariant);
        }
        updateURL() {
          window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
        }
        updateFormID() {
          const form_input = document.querySelector("#product-form").querySelector('input[name="id"]');
          form_input.value = this.currentVariant.id;
        }
        updatePrice() {
          fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const id = `price-${this.dataset.section}`;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const oldPrice = document.getElementById(id);
            const newPrice = html.getElementById(id);
            if(oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;
          });
        }
      }
      customElements.define("variant-selector", VariantSelector);
  
  // Quantity Selector
  
      var spins = document.getElementsByClassName("qty");
      for (var i = 0, len = spins.length; i < len; i++) {
        var spin = spins[i],
            span = spin.getElementsByTagName("span"),
            input = spin.getElementsByTagName("input")[0];
  
        input.onchange = function() {
          input.value = +input.value || 0;
        };
        span[0].onclick = function() {
          input.value = Math.max(1, input.value - 1);
        };
        span[1].onclick = function() {
          input.value -= -1;
        };
      }
  
  // Product Slider
  
  var swiper = new Swiper(".mySwiper", {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    
  });
  var swiper2 = new Swiper(".mySwiper2", {
    loop: true,
    spaceBetween: 10,
    autoHeight:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });